import request from '../request';
// 【TCT货盘】货盘编辑
export function cargoOrderTctAddApi(params) {
    return request.post('/cargo/order/tct/add', params);
}
// 【TCT货盘】货盘列表
export function cargoOrderTctOwnedApi(cls) {
    return request.post('/cargo/order/tct/owned', { class: cls });
}
// 【TC货盘】【Broker】获取委托代理的TC货盘
export function agentTcOrderReceivedApi(cls, offset, filter) {
    return request.post('/agent/tc-order/received', { class: cls, offset, filter });
}
// 【TCT货盘】获取TCT货盘所有信息
export function cargoOrderTctInformationdAllApi(orderId, ownerId) {
    return request.post('/cargo/order/tct/information/all', { orderId, ownerId });
}
// 【TCT货盘】将货盘放入回收站
export function cargoOrderTctTrashApi(id) {
    return request.post('/cargo/order/tct/trash', { id });
}
// 【TCT货盘】恢复货盘
export function cargoOrderTctRecoverApi(id) {
    return request.post('/cargo/order/tct/recover', { id });
}
// 【货盘】强制删除货盘
export function cargoOrderTctDeleteApi(id) {
    return request.post('/cargo/order/tct/delete', { id });
}
// 【TCT货盘】获取TCT货盘发布时的设置信息(TO/CC)
export function cargoOrderTctInfoPublishedApi(orderId, ownerId, voyageId) {
    return request.post('/cargo/order/tct/information/published', { orderId, ownerId, voyageId });
}
// 【TCT货盘】获取与货盘匹配的最新船盘
export function cargoOrderTctMatchedLatestApi(orderId, ownerId) {
    return request.post('/cargo/order/tct/matched/latest', { orderId, ownerId });
}
// 【TCT货盘】发布TCT货盘
export function orderTctPublishApi(params) {
    return request.post('/cargo/order/tct/publish', params);
}
// 【货盘】获取货盘发布时的设置信息
export function cargoOrderTctInformationPublishApi(para) {
    return request.post('cargo/order/tct/information/published', para);
}
